import { formatCUITCUILWithDash } from "../../utils/utils";

export const messages = {
    loading: "Buscando Ordenes de pago...",
    noResults: (cuit) => `No se encontraron Ordenes de pago para el CUIT: ${formatCUITCUILWithDash(cuit)}`,
    results: (cuit, cantResults) => `Se ${cantResults > 1 ? 'encontraron' : 'encontró'} ${cantResults} ${cantResults > 1 ? 'órdenes' : 'órden'} de pago para el CUIT:  ${formatCUITCUILWithDash(cuit)}`
}